import { render, staticRenderFns } from "./RegisterTeacher.vue?vue&type=template&id=b526da7a&scoped=true&"
import script from "./RegisterTeacher.vue?vue&type=script&lang=js&"
export * from "./RegisterTeacher.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTeacher.vue?vue&type=style&index=0&id=b526da7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b526da7a",
  null
  
)

export default component.exports